import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import useSelection from '../hooks/use-selection'
import { useValue } from '../hooks'

function ToggleSelectionOnClick ({
  multiple = false,
  autoMultiple = false,
  onClick = null,
  children
}) {
  const selection = useSelection()
  const modelKey = useValue(selection.modelKeyName)

  const handleClick = (e) => {

    if (!modelKey) {
      return
    }

    if(e && typeof e.persist === 'function') {
      e.persist()
    }

    if(typeof onClick === 'function') {
      onClick(e)
    }

    if (multiple === false || (autoMultiple === true && !e.ctrlKey) ) {
      selection.clearSelected()
    }

    const toSelect = !selection.isSelected(modelKey)

    if (toSelect === true) {
      selection.add(modelKey)
    } else {
      selection.delete(modelKey)
    }
  }

  return (
    <>
      {React.Children.map(children, child => (
        React.cloneElement(child, { onClick: handleClick })
      ))}
    </>
  )
}

ToggleSelectionOnClick.propTypes = {
  multiple: PropTypes.bool,
  /** Only allow multiple selection if CTRL is down while clicking  */
  autoMultiple: PropTypes.bool,
  onClick: PropTypes.func
}

export default observer(ToggleSelectionOnClick)
